import { Box, Tab, Tabs, Typography } from '@mui/material'
import EastIcon from '@mui/icons-material/East'
import { renderCountBadge } from 'components/custom/AdxLabelRenderer'

const RecruitmentTabs = ({ value, handleChange, jobStats }) => {
  const {
    matched_count,
    applied_count,
    shortlisted_count,
    interview_count,
    offered_count,
    hired_count,
    rejected_count,
  } = jobStats.data?.aggregates || {}

  const error = jobStats.error

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}>
      <Tabs
        TabIndicatorProps={{
          sx: {
            backgroundColor: 'alternate.main',
            height: '2.5px',
          },
        }}
        variant="fullWidth"
        value={value}
        onChange={handleChange}
        scrollButtons={false}
      >
        <Tab
          label={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                color: value === 0 ? 'alternate.main' : 'light-gray-text.main',
              }}
            >
              {renderCountBadge(
                matched_count === null || matched_count === undefined || error !== null
                  ? '0'
                  : matched_count
              )}
              <Typography>Matched</Typography>
            </Box>
          }
        />
        <Tab
          label={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                color: value === 1 ? 'alternate.main' : 'light-gray-text.main',
              }}
            >
              {renderCountBadge(
                applied_count === null || applied_count === undefined || error !== null
                  ? '0'
                  : applied_count
              )}
              <Typography>Applied</Typography>
            </Box>
          }
        />
        <Box display="flex" justifyContent="center" alignItems="center">
          <EastIcon color="light-gray-text-2" />
        </Box>
        <Tab
          label={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                color: value === 3 ? 'alternate.main' : 'light-gray-text.main',
              }}
            >
              {renderCountBadge(
                shortlisted_count === null || shortlisted_count === undefined || error !== null
                  ? '0'
                  : shortlisted_count
              )}
              <Typography>Shortlisted</Typography>
            </Box>
          }
        />
        <Box display="flex" justifyContent="center" alignItems="center">
          <EastIcon color="light-gray-text-2" />
        </Box>
        <Tab
          label={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                color: value === 5 ? 'alternate.main' : 'light-gray-text.main',
              }}
            >
              {renderCountBadge(
                interview_count === null || interview_count === undefined || error !== null
                  ? '0'
                  : interview_count
              )}
              <Typography>Interview</Typography>
            </Box>
          }
        />
        <Box display="flex" justifyContent="center" alignItems="center">
          <EastIcon color="light-gray-text-2" />
        </Box>
        <Tab
          label={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                color: value === 7 ? 'alternate.main' : 'light-gray-text.main',
              }}
            >
              {renderCountBadge(
                offered_count === null || offered_count === undefined || error !== null
                  ? '0'
                  : offered_count
              )}
              <Typography>Offer</Typography>
            </Box>
          }
        />
        <Box display="flex" justifyContent="center" alignItems="center">
          <EastIcon color="light-gray-text-2" />
        </Box>
        <Tab
          label={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                color: value === 9 ? 'alternate.main' : 'light-gray-text.main',
              }}
            >
              {renderCountBadge(
                hired_count === null || hired_count === undefined || error !== null
                  ? '0'
                  : hired_count
              )}
              <Typography>Hired</Typography>
            </Box>
          }
        />
        <Tab
          sx={{ borderLeft: 1, borderLeftColor: 'gray-line.main' }}
          label={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                color: value === 10 ? 'alternate.main' : 'light-gray-text.main',
              }}
            >
              {renderCountBadge(
                rejected_count === null || rejected_count === undefined || error !== null
                  ? '0'
                  : rejected_count
              )}
              <Typography>Rejected</Typography>
            </Box>
          }
        />
      </Tabs>
    </Box>
  )
}

export default RecruitmentTabs
